import * as moment from 'moment';

export class DateFormatValueConverter {
	toView(value: any, format: any) {
		return value ? moment(value).format(format) : value;
	}
}
